import React, { useCallback, useEffect, useState } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import { getAllItemIncremental } from "../../Item/services/item.services";
import {
  clearSalesRegisterDetails,
  clearSalesRegisterList,
  setSalesRegisterReport,
} from "../reportsSlice";
import AlertBox from "../../../components/common/AlertBox";
import { LoadingPanel } from "../../../components/layout/Loading";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import FormIncrementalSearch from "../../../components/formFields/FormIncrementalSearch";
import { clearItemList } from "../../Item/itemSlice";
import { Button } from "@progress/kendo-react-buttons";
import Logo from "../../../assets/Images/logo.png";
import {
  checkAcessRights,
  formatIndianNumber,
  formatIndianNumberForQty,
} from "../../../_helper/helper";
import {
  EDIT_ACCESS,
  EXCEL_EXPORT_ACCESS,
  PRINT_ACCESS,
} from "../../../_contstants/common";
import { getAllAccountIncremental } from "../../account/services/account.services";
import { RxCross2 } from "react-icons/rx";
import FormCheckboxGroup from "../../../components/formFields/FormCheckboxGroup";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { BsThreeDotsVertical } from "react-icons/bs";
import { getSalesRegisterReport } from "../services/reports.services";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { IItemGroup } from "../../ItemGroup/itemgroupModel";
import { findAllActiveItemGroup } from "../../ItemGroup/services/itemgroup.services";
import { IItem } from "../../Item/itemModel";
import { FiEdit } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import IconButton from "../../../components/common/IconButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { findAllVoucherTypeByType } from "../../vouchertype/services/voucherType.services";
import { IVoucherType } from "../../vouchertype/voucherTypeModel";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const DummyChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const createdBy = localStorage.getItem("UserID");
  useEffect(() => {
    formRenderProps.onChange("UserID", {
      value: createdBy,
    });
  }, []);

  return null;
};

const SalesRegisterReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const ItemList = useAppSelector((state) => state.item.ItemList);
  const ItemGroupList = useAppSelector(
    (state) => state.itemgroup.ItemGroupList
  )?.filter((item: any) => item.isdisplaysalesorder);
  const VoucherTypeList = useAppSelector(
    (state) => state.voucherType.VoucherTypeList
  );
  const SalesRegisterList = useAppSelector(
    (state) => state.reports.SalesRegisterList
  );
  const SalesRegisterDetails = useAppSelector(
    (state) => state.reports.SalesRegisterDetails
  );
  const [initialValue, setInitialValue] = useState<any>({});
  const [formKey, setFormKey] = useState<any>(1);

  useEffect(() => {
    setInitialValue({
      ...SalesRegisterDetails,
      from_date: SalesRegisterDetails?.from_date
        ? moment(SalesRegisterDetails?.from_date, "YYYY-MM-DD").toDate()
        : null,
      to_date: SalesRegisterDetails?.to_date
        ? moment(SalesRegisterDetails?.to_date, "YYYY-MM-DD").toDate()
        : null,
    });
    setFormKey(formKey + 1);
  }, [SalesRegisterDetails]);

  useEffect(() => {
    dispatch(findAllVoucherTypeByType(1));
    dispatch(findAllActiveItemGroup());
  }, []);

  const handleVendorSearchChange = useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllAccountIncremental(search));
      formRenderProps.onChange(field, {
        value: result.payload,
      });
    },
    [dispatch]
  );

  const handleSubmit = async (values: any) => {
    const payload = {
      item_id: values?.item_id ? values?.item_id : null,
      item_group_id: values?.item_group_id ? values?.item_group_id : null,
      vendor_id: values?.vendor_id ? values?.vendor_id : null,
      voucher_type_id: values?.voucher_type_id
        ? +values?.voucher_type_id
        : null,
      from_date: values?.from_date
        ? moment(values?.from_date).format("YYYY-MM-DD")
        : null,
      to_date: values?.to_date
        ? moment(values?.to_date).format("YYYY-MM-DD")
        : null,
    };
    const setPayload = {
      ...payload,
      vendor_options: values?.vendor_options || [],
      item_options: values?.item_options || [],
      isSalesRef: true,
    };
    await dispatch(getSalesRegisterReport(payload));

    dispatch(setSalesRegisterReport(setPayload));
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            key={formKey}
            initialValues={initialValue}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Sales Register
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="from_date"
                      label="From Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="to_date"
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={
                        moment(
                          formRenderProps.valueGetter("from_date")
                        ).toDate() || new Date(1900, 0, 1)
                      }
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="voucher_type_id"
                      label="Voucher Type"
                      placeholder="Voucher Type"
                      // astrike={true}
                      // validator={requiredValidator}
                      component={FormSelectionField}
                      options={VoucherTypeList?.map((type: IVoucherType) => {
                        return {
                          value: type?.id,
                          label: type?.name,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem></GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="vendor_id"
                      label="Customer"
                      placeholder="Type here to search customer..."
                      component={FormIncrementalSearch}
                      fetchIncrementalData={(search: any) =>
                        handleVendorSearchChange(
                          search,
                          `vendor_options`,
                          formRenderProps
                        )
                      }
                      options={
                        formRenderProps
                          .valueGetter("vendor_options")
                          ?.map((item: any) => {
                            return {
                              value: item.id,
                              label: item.account_name,
                            };
                          }) || []
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="item_group_id"
                      label="Product Group Name"
                      placeholder="Product Group Name"
                      component={FormSelectionField}
                      //   validator={requiredValidator}
                      //   astrike={true}
                      options={ItemGroupList?.map((itemgroup: IItemGroup) => {
                        return {
                          value: itemgroup?.id,
                          label: itemgroup?.item_group,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      name="item_id"
                      label="Product Name"
                      placeholder="Type here to search item..."
                      component={FormIncrementalSearch}
                      fetchIncrementalData={(search: any) =>
                        !formRenderProps.valueGetter("item_group_id") ||
                        formRenderProps.valueGetter("item_group_id") === null
                          ? dispatch(
                              getAllItemIncremental({
                                search: search,
                              })
                            )
                          : dispatch(
                              getAllItemIncremental({
                                search: search,
                                item_group_id:
                                  formRenderProps.valueGetter("item_group_id"),
                              })
                            )
                      }
                      //   loading={itemLoading}
                      options={ItemList?.map((item: IItem) => {
                        return {
                          value: item?.id,
                          label: item?.product_name,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={3}
                    style={{
                      textAlign: "end",
                      marginTop: 36,
                    }}
                  >
                    <ButtonWithLoading
                      label={"View"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                  </GridLayoutItem>
                </GridLayout>
                <DummyChangeWatcher formRenderProps={formRenderProps} />
              </FormElement>
            )}
          />
        </ShadowCard>
        {/* {loading ? (
          <LoadingPanel gridRef={gridRef} />
        ) : ( */}
        {SalesRegisterList && SalesRegisterList.length > 0 && (
          <ShadowCard style={{ marginTop: 10 }}>
            <SalesRegisterGridCommponent />
          </ShadowCard>
        )}
        {/* )} */}
      </GridLayoutItem>
    </GridLayout>
  );
};

const columns = [
  //   { label: "Invoice No.", value: "invoice_no" },
  { label: "Invoice Date", value: "invoice_date" },
  { label: "Voucher Type", value: "voucher_type_name" },
  { label: "Customer Name", value: "account_name" },
  { label: "Item Name", value: "product_name" },
  { label: "Lot No.", value: "lot_no" },
  { label: "Qty", value: "quantity" },
  { label: "Free Qty", value: "free_quantity" },
  { label: "Unit", value: "unit_name" },
  { label: "MRP", value: "mrp" },
  { label: "Rate", value: "rate" },
  { label: "Vatav(%)", value: "vatav_per" },
  { label: "Vatav", value: "vatav" },
  { label: "Taxable Amount ", value: "taxable_amount" },
  { label: "CGST(%)", value: "cgst" },
  { label: "CGST Amount", value: "cgst_amount" },
  { label: "SGST(%)", value: "sgst" },
  { label: "SGST Amount", value: "sgst_amount" },
  { label: "IGST(%)", value: "igst" },
  { label: "IGST Amount", value: "igst_amount" },
  { label: "Total Amount", value: "total_amount" },
  { label: "Total Taxable Amount", value: "total_taxable_amount" },

  {
    label: "GST Sales Nill Rate Amount",
    value: "gst_sales_nill_rate_taxable_amount",
  },
  {
    label: "IGST Sales Nill Rate Amount",
    value: "i_gst_sales_nill_rate_taxable_amount",
  },
  { label: "Sales GST 5%", value: "gst_sales_5_taxable_amount" },
  { label: "CGST 2.5%", value: "cgst_2_5_gst_amount" },
  { label: "SGST 2.5%", value: "sgst_2_5_gst_amount" },
  { label: "Sales IGST 5%", value: "i_gst_sales_5_taxable_amount" },
  { label: "IGST 5%", value: "igst_5_gst_amount" },
  { label: "Sales GST 12%", value: "gst_sales_12_taxable_amount" },
  { label: "CGST 6%", value: "cgst_6_gst_amount" },
  { label: "SGST 6%", value: "sgst_6_gst_amount" },
  { label: "Sales IGST 12%", value: "i_gst_sales_12_taxable_amount" },
  { label: "IGST 12%", value: "igst_12_gst_amount" },
  { label: "Sales GST 18%", value: "gst_sales_18_taxable_amount" },
  { label: "CGST 9%", value: "cgst_9_gst_amount" },
  { label: "SGST 9%", value: "sgst_9_gst_amount" },
  { label: "Sales IGST 18%", value: "i_gst_sales_18_taxable_amount" },
  { label: "IGST 18%", value: "igst_18_gst_amount" },
  { label: "Sales GST 28%", value: "gst_sales_28_taxable_amount" },
  { label: "SGST 14%", value: "sgst_14_gst_amount" },
  { label: "CGST 14%", value: "cgst_14_gst_amount" },
  { label: "Sales IGST 28%", value: "i_gst_sales_28_taxable_amount" },
  { label: "IGST 28%", value: "igst_28_gst_amount" },
  { label: "CESS 12%", value: "cess_12_taxable_amount" },
  // {
  //   label: "GST Sales Nill Rate Ledger Name",
  //   value: "gst_sales_nill_rate_ledger_name",
  // },

  // { label: "Total CGST Amount", value: "total_cgst" },
  // { label: "Total SGST Amount", value: "total_sgst" },
  // { label: "Total IGST Amount", value: "total_igst" },

  { label: "Freight", value: "frieght" },
  { label: "Grand Total Amount", value: "gross_total" },
  { label: "Terms Day", value: "terms_day" },
  { label: "Due Date", value: "due_date" },
  { label: "Vehicle No.", value: "vehicle_no" },
  { label: "Cartoon", value: "cartoon" },
  { label: "Bag", value: "bag" },
];
const SalesRegisterGridCommponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const gridRef = React.useRef<any>(null);
  const isEditBtnRef = React.useRef<any>(false);
  const isEditAccess = checkAcessRights("/sales", EDIT_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );

  const loading = useAppSelector((state) => state.reports.loading);
  const SalesRegisterList = useAppSelector(
    (state) => state.reports.SalesRegisterList
  );
  const SalesRegisterDetails = useAppSelector(
    (state) => state.reports.SalesRegisterDetails
  );
  const [showfilterColumns, setShowFilterColumns] = React.useState(false);
  const [selectedGroup, setSelectedGroup] = React.useState<string | null>(null);

  useEffect(() => {
    return () => {
      if (!isEditBtnRef.current) {
        dispatch(clearSalesRegisterList());
        dispatch(clearSalesRegisterDetails());
        dispatch(clearItemList());
      }
    };
  }, []);

  const handleExportExcel = () => {
    const datetime = moment().format("DD-MM-YYYY HH-mm");
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".currentstock-print-table")
    );
    XLSX.utils.book_append_sheet(wb, ws, "SalesRegisterReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, `Sales Register Report ${datetime}`);
  };

  const handleRowClick = (sale_guid: string) => {
    const groupKey = `${sale_guid}`;
    setSelectedGroup(selectedGroup === groupKey ? null : groupKey);
  };

  const initialValues = {
    filter_columns: [
      //   "invoice_no",
      "voucher_type_name",
      "invoice_date",
      "account_name",
      // "product_name",
      // "lot_no",
      // "quantity",
      // "free_quantity",
      // "unit_name",
      // "mrp",
      // "rate",
      // "vatav_per",
      // "vatav",
      // "taxable_amount",
      // "cgst",
      // "cgst_amount",
      // "sgst",
      // "sgst_amount",
      // "igst",
      // "igst_amount",
      // "gst_sales_nill_rate_ledger_name",
      "gst_sales_nill_rate_taxable_amount",
      "i_gst_sales_nill_rate_taxable_amount",
      "gst_sales_5_taxable_amount",
      "cgst_2_5_gst_amount",
      "sgst_2_5_gst_amount",
      "i_gst_sales_5_taxable_amount",
      "igst_5_gst_amount",
      "gst_sales_12_taxable_amount",
      "cgst_6_gst_amount",
      "sgst_6_gst_amount",
      "i_gst_sales_12_taxable_amount",
      "igst_12_gst_amount",
      "gst_sales_18_taxable_amount",
      "cgst_9_gst_amount",
      "sgst_9_gst_amount",
      "i_gst_sales_18_taxable_amount",
      "igst_18_gst_amount",
      "gst_sales_28_taxable_amount",
      "sgst_14_gst_amount",
      "cgst_14_gst_amount",
      "i_gst_sales_28_taxable_amount",
      "igst_28_gst_amount",
      "cess_12_taxable_amount",
      // "total_amount",
      "total_taxable_amount",
      // "total_cgst",
      // "total_sgst",
      // "total_igst",
      // "frieght",

      "gross_total",

      // "terms_day",
      // "due_date",
      // "vehicle_no",
      // "cartoon",
      // "bag",
    ],
  };

  const GrandTotalArray: any = [
    "quantity",
    "free_quantity",
    "vatav",
    "taxable_amount",
    "cgst_amount",
    "sgst_amount",
    "igst_amount",
    "total_amount",
    "total_taxable_amount",
    "total_cgst",
    "total_sgst",
    "total_igst",
    "frieght",
    "gross_total",
  ];

  const groupedData = SalesRegisterList.reduce((acc: any, item: any) => {
    const { sale_guid } = item;
    acc[sale_guid] = acc[sale_guid] || [];
    acc[sale_guid].push(item);
    return acc;
  }, {});
  const groupedArray = Object.values(groupedData);

  let totalQty = 0;
  let totalFreeQty = 0;
  let totalVatav = 0;
  let totalTaxableAmount = 0;
  let totalCGSTAmount = 0;
  let totalSGSTAmount = 0;
  let totalIGSTAmount = 0;
  let totalGSTWithAmount = 0;
  let totalGrandTaxableAmount = 0;

  let totalGrandGSTSalesTaxableAmount = 0;
  let totalGrandIGSTSalesTaxableAmount = 0;
  let totalGrandSalesGST5Amount = 0;
  let totalGrandCGST2_5Amount = 0;
  let totalGrandSGST2_5Amount = 0;
  let totalGrandSalesIGST5Amount = 0;
  let totalGrandIGST5Amount = 0;
  let totalGrandSalesGST12Amount = 0;
  let totalGrandCGST6Amount = 0;
  let totalGrandSGST6Amount = 0;
  let totalGrandSalesIGST12Amount = 0;
  let totalGrandIGST12Amount = 0;
  let totalGrandSalesGST18Amount = 0;
  let totalGrandCGST9Amount = 0;
  let totalGrandSGST9Amount = 0;
  let totalGrandSalesIGST18Amount = 0;
  let totalGrandIGST18Amount = 0;
  let totalGrandSalesGST28Amount = 0;
  let totalGrandCGST14Amount = 0;
  let totalGrandSGST14Amount = 0;
  let totalGrandSalesIGST28Amount = 0;
  let totalGrandIGST28Amount = 0;
  let totalGrandCESS12Amount = 0;

  // let GrandtotalCGSTAmount = 0;
  // let GrandtotalSGSTAmount = 0;
  // let GrandtotalIGSTAmount = 0;
  let totalFreightAmount = 0;
  let GrandTotalAmount = 0;

  groupedArray &&
    groupedArray.length > 0 &&
    groupedArray?.map((group: any) => {
      group?.map((item: any, index: number) => {
        totalQty += item?.quantity || 0;
        totalFreeQty += item?.free_quantity || 0;
        totalVatav += item?.vatav || 0;
        totalTaxableAmount += item?.taxable_amount || 0;
        totalCGSTAmount += item?.cgst_amount || 0;
        totalSGSTAmount += item?.sgst_amount || 0;
        totalIGSTAmount += item?.igst_amount || 0;
        totalGSTWithAmount += item?.total_amount || 0;

        if (index === 0) {
          totalGrandTaxableAmount += item?.total_taxable_amount || 0;
          // GrandtotalCGSTAmount += item?.total_cgst || 0;
          // GrandtotalSGSTAmount += item?.total_sgst || 0;
          // GrandtotalIGSTAmount += item?.total_igst || 0;
          totalFreightAmount += item?.frieght || 0;
          GrandTotalAmount += item?.gross_total || 0;

          totalGrandGSTSalesTaxableAmount +=
            +item.gst_sales_nill_rate_taxable_amount || 0;
          totalGrandIGSTSalesTaxableAmount +=
            +item.i_gst_sales_nill_rate_taxable_amount || 0;
          totalGrandSalesGST5Amount += item.gst_sales_5_taxable_amount || 0;
          totalGrandCGST2_5Amount += item.cgst_2_5_gst_amount || 0;
          totalGrandSGST2_5Amount += item.sgst_2_5_gst_amount || 0;
          totalGrandSalesIGST5Amount += item.i_gst_sales_5_taxable_amount || 0;
          totalGrandIGST5Amount += item.igst_5_gst_amount || 0;
          totalGrandSalesGST12Amount += item.gst_sales_12_taxable_amount || 0;
          totalGrandCGST6Amount += item.cgst_6_gst_amount || 0;
          totalGrandSGST6Amount += item.sgst_6_gst_amount || 0;
          totalGrandSalesIGST12Amount +=
            item.i_gst_sales_12_taxable_amount || 0;
          totalGrandIGST12Amount += item.igst_12_gst_amount || 0;
          totalGrandSalesGST18Amount += item.gst_sales_18_taxable_amount || 0;
          totalGrandCGST9Amount += item.cgst_9_gst_amount || 0;
          totalGrandSGST9Amount += item.sgst_9_gst_amount || 0;
          totalGrandSalesIGST18Amount +=
            item.i_gst_sales_18_taxable_amount || 0;
          totalGrandIGST18Amount += item.igst_18_gst_amount || 0;
          totalGrandSalesGST28Amount += item.gst_sales_28_taxable_amount || 0;
          totalGrandCGST14Amount += item.sgst_14_gst_amount || 0;
          totalGrandSGST14Amount += item.cgst_14_gst_amount || 0;
          totalGrandSalesIGST28Amount +=
            item.i_gst_sales_28_taxable_amount || 0;
          totalGrandIGST28Amount += item.igst_28_gst_amount || 0;
          totalGrandCESS12Amount += item.cess_12_taxable_amount || 0;
        }
      });
    });

  const printTable = (data: any[], formRenderProps: any) => {
    const isfilter = (key: string) =>
      formRenderProps.valueGetter("filter_columns")?.includes(key);

    let printbuttons = document.querySelector(
      ".printbuttons"
    ) as HTMLElement | null;
    let report_container = document.querySelector(
      ".report-container"
    ) as HTMLElement | null;

    if (printbuttons) printbuttons.style.display = "none";
    if (report_container) report_container.style.padding = "20px 0";

    let tableRows = data.length;
    let maxRows = tableRows;
    let pageCount = Math.ceil(tableRows / maxRows);

    let content = "";

    for (let i = 0; i < pageCount; i++) {
      content += '<div class="print-page">';
      content +=
        '<table class="table table-bordered" style="font-size:10px;margin-bottom:30px;">';
      content += "<tr>";
      content += `<td rowSpan="3" style="width:15%" ><img src="${Logo}" width="100%" /></td>`;
      content +=
        '<td colSpan="2" style="text-align: center;font-size: 14px;font-weight: 600;color: gray;">Harihar Foods Pvt Ltd.</td>';
      content += "</tr>";
      content += "<tr>";
      content +=
        '<td colSpan="2"><h3 style="margin:0;">Sales Register Report</h3></td>';
      content += "</tr>";
      content += "<tr>";
      content += `<td style="text-align:end;">Page : ${i + 1}</td>`;
      content += "</tr>";

      content += "</table>";

      content += '<table class="table table-bordered" style="font-size:10px;">';
      content += '<thead style="background:lightgray;">';
      content += "<tr>";
      content += '<th style="width:30px;">Invoice No.</th>';
      {
        isfilter("voucher_type_name") && (content += "<th>Voucher Type</th>");
      }
      {
        isfilter("invoice_date") && (content += "<th>Invoice Date</th>");
      }
      {
        isfilter("account_name") && (content += "<th>Customer Name</th>");
      }
      {
        isfilter("product_name") &&
          (content += '<th style="min-width:150px;">Item Name</th>');
      }
      {
        isfilter("lot_no") && (content += "<th>Lot No.</th>");
      }
      {
        isfilter("quantity") && (content += "<th>Qty</th>");
      }
      {
        isfilter("free_quantity") && (content += "<th>Free Qty</th>");
      }
      {
        isfilter("unit_name") && (content += "<th>Unit</th>");
      }
      {
        isfilter("mrp") && (content += "<th>MRP</th>");
      }
      {
        isfilter("rate") && (content += "<th>Rate</th>");
      }
      {
        isfilter("vatav_per") && (content += "<th>Vatav(%)</th>");
      }
      {
        isfilter("vatav") && (content += "<th>Vatav</th>");
      }
      {
        isfilter("taxable_amount") && (content += "<th>Taxable Amount</th>");
      }
      {
        isfilter("cgst") && (content += "<th>CGST(%)</th>");
      }
      {
        isfilter("cgst_amount") && (content += "<th>CGST Amount</th>");
      }
      {
        isfilter("sgst") && (content += "<th>SGST(%)</th>");
      }
      {
        isfilter("sgst_amount") && (content += "<th>SGST Amount</th>");
      }
      {
        isfilter("igst") && (content += "<th>IGST(%)</th>");
      }
      {
        isfilter("igst_amount") && (content += "<th>IGST Amount</th>");
      }
      {
        isfilter("total_amount") && (content += "<th>Total Amount</th>");
      }
      {
        isfilter("total_taxable_amount") &&
          (content += "<th>Total Taxable Amount</th>");
      }
      // {
      //   isfilter("total_cgst") && (content += "<th>Total CGST Amount</th>");
      // }
      // {
      //   isfilter("total_sgst") && (content += "<th>Total SGST Amount</th>");
      // }
      // {
      //   isfilter("total_igst") && (content += "<th>Total IGST Amount</th>");
      // }

      {
        isfilter("gst_sales_5_taxable_amount") &&
          (content += "<th>Sales GST 5%</th>");
      }
      {
        isfilter("cgst_2_5_gst_amount") && (content += "<th>CGST 2.5%</th>");
      }
      {
        isfilter("sgst_2_5_gst_amount") && (content += "<th>SGST 2.5%</th>");
      }
      {
        isfilter("i_gst_sales_5_taxable_amount") &&
          (content += "<th>Sales IGST 5%</th>");
      }
      {
        isfilter("igst_5_gst_amount") && (content += "<th>IGST 5%</th>");
      }
      {
        isfilter("gst_sales_12_taxable_amount") &&
          (content += "<th>Sales GST 12%</th>");
      }
      {
        isfilter("cgst_6_gst_amount") && (content += "<th>CGST 6%</th>");
      }
      {
        isfilter("sgst_6_gst_amount") && (content += "<th>SGST 6%</th>");
      }
      {
        isfilter("i_gst_sales_12_taxable_amount") &&
          (content += "<th>Sales IGST 12%</th>");
      }
      {
        isfilter("igst_12_gst_amount") && (content += "<th>IGST 12%</th>");
      }
      {
        isfilter("gst_sales_18_taxable_amount") &&
          (content += "<th>Sales GST 18%</th>");
      }
      {
        isfilter("cgst_9_gst_amount") && (content += "<th>CGST 9%</th>");
      }
      {
        isfilter("sgst_9_gst_amount") && (content += "<th>SGST 9%</th>");
      }
      {
        isfilter("i_gst_sales_18_taxable_amount") &&
          (content += "<th>Sales IGST 9%</th>");
      }
      {
        isfilter("igst_18_gst_amount") && (content += "<th>IGST 9%</th>");
      }
      {
        isfilter("gst_sales_28_taxable_amount") &&
          (content += "<th>Sales GST 28%</th>");
      }
      {
        isfilter("sgst_14_gst_amount") && (content += "<th>CGST 14%</th>");
      }
      {
        isfilter("cgst_14_gst_amount") && (content += "<th>SGST 14%</th>");
      }
      {
        isfilter("i_gst_sales_28_taxable_amount") &&
          (content += "<th>Sales IGST 28%</th>");
      }
      {
        isfilter("igst_28_gst_amount") && (content += "<th>IGST 28%</th>");
      }
      {
        isfilter("cess_12_taxable_amount") && (content += "<th>CESS 12%</th>");
      }
      // {
      //   isfilter("gst_sales_nill_rate_ledger_name") &&
      //     (content += "<th>GST Sales Nill Rate Ledger Name</th>");
      // }
      {
        isfilter("gst_sales_nill_rate_taxable_amount") &&
          (content += "<th>GST Sales Nill Rate Amount</th>");
      }
      {
        isfilter("i_gst_sales_nill_rate_taxable_amount") &&
          (content += "<th>IGST Sales Nill Rate Amount</th>");
      }
      {
        isfilter("frieght") && (content += "<th>Freight</th>");
      }
      {
        isfilter("gross_total") && (content += "<th>Grand Total Amount</th>");
      }
      {
        isfilter("terms_day") && (content += "<th>Terms Day</th>");
      }
      {
        isfilter("due_date") && (content += "<th>Due Date</th>");
      }
      {
        isfilter("vehicle_no") && (content += "<th>Vehicle No.</th>");
      }
      {
        isfilter("cartoon") && (content += "<th>Cartoon</th>");
      }
      {
        isfilter("bag") && (content += "<th>Bag</th>");
      }
      content += "</tr>";
      content += "</thead>";
      content += "<tbody>";

      // let startRow = i * maxRows;
      // let endRow = Math.min((i + 1) * maxRows, tableRows);

      data.map((group: any) =>
        group.map((item: any, index: any) => {
          content += "<tr>";
          index === 0 &&
            (content += `<td rowspan="${group.length}" >${
              item.invoice_no_string ? item.invoice_no_string : ""
            }</td>`);
          {
            isfilter("voucher_type_name") &&
              index === 0 &&
              (content += `<td rowspan="${group.length}" >${item.voucher_type_name}</td>`);
          }
          {
            isfilter("invoice_date") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:center;">${
                item?.invoice_date
                  ? moment(item?.invoice_date, "DD/MM/YYYY").format(
                      "DD MMM YYYY"
                    )
                  : ""
              }</td>`);
          }
          {
            isfilter("account_name") &&
              index === 0 &&
              (content += `<td rowspan="${group.length}" >${item.account_name}</td>`);
          }
          {
            isfilter("product_name") &&
              (content += `<td>${item.product_name}</td>`);
          }
          {
            isfilter("lot_no") &&
              (content += `<td>${item.lot_no ? item.lot_no : ""}</td>`);
          }
          {
            isfilter("quantity") &&
              (content += `<td style="text-align:end;">${
                item.quantity ? formatIndianNumber(item.quantity) : 0
              }</td>`);
          }
          {
            isfilter("free_quantity") &&
              (content += `<td style="text-align:end;">${
                item.free_quantity ? formatIndianNumber(item.free_quantity) : 0
              }</td>`);
          }
          {
            isfilter("unit_name") && (content += `<td>${item.unit_code}</td>`);
          }
          {
            isfilter("mrp") && (content += `<td>${item.mrp}</td>`);
          }
          {
            isfilter("rate") &&
              (content += `<td style="text-align:end;">${
                item.rate ? formatIndianNumber(item.rate) : 0
              }</td>`);
          }
          {
            isfilter("vatav_per") &&
              (content += `<td style="text-align:end;">${
                item.vatav_per ? `${item.vatav_per} %` : ""
              }</td>`);
          }
          {
            isfilter("vatav") &&
              (content += `<td style="text-align:end;">${
                item.vatav ? formatIndianNumber(item.vatav) : ""
              }</td>`);
          }
          {
            isfilter("taxable_amount") &&
              (content += `<td style="text-align:end;">${
                item.taxable_amount
                  ? formatIndianNumber(item.taxable_amount)
                  : 0
              }</td>`);
          }
          {
            isfilter("cgst") &&
              (content += `<td style="text-align:end;">${
                item.cgst ? `${item.cgst} %` : ""
              }</td>`);
          }
          {
            isfilter("cgst_amount") &&
              (content += `<td style="text-align:end;">${
                item.cgst_amount ? formatIndianNumber(item.cgst_amount) : ""
              }</td>`);
          }
          {
            isfilter("sgst") &&
              (content += `<td style="text-align:end;">${
                item.sgst ? `${item.sgst} %` : ""
              }</td>`);
          }
          {
            isfilter("sgst_amount") &&
              (content += `<td style="text-align:end;">${
                item.sgst_amount ? formatIndianNumber(item.sgst_amount) : ""
              }</td>`);
          }
          {
            isfilter("igst") &&
              (content += `<td style="text-align:end;">${
                item.igst ? `${item.igst} %` : ""
              }</td>`);
          }
          {
            isfilter("igst_amount") &&
              (content += `<td style="text-align:end;">${
                item.igst_amount ? formatIndianNumber(item.igst_amount) : ""
              }</td>`);
          }
          {
            isfilter("total_amount") &&
              (content += `<td style="text-align:end;">${
                item.total_amount ? formatIndianNumber(item.total_amount) : ""
              }</td>`);
          }
          {
            isfilter("total_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.total_taxable_amount
                  ? formatIndianNumber(item.total_taxable_amount)
                  : ""
              }</td>`);
          }
          // {
          //   isfilter("total_cgst") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${
          //       group.length
          //     }" style="text-align:end;">${
          //       item.total_cgst ? formatIndianNumber(item.total_cgst) : ""
          //     }</td>`);
          // }
          // {
          //   isfilter("total_sgst") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${
          //       group.length
          //     }" style="text-align:end;">${
          //       item.total_sgst ? formatIndianNumber(item.total_sgst) : ""
          //     }</td>`);
          // }
          // {
          //   isfilter("total_igst") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${
          //       group.length
          //     }" style="text-align:end;">${
          //       item.total_igst ? formatIndianNumber(item.total_igst) : ""
          //     }</td>`);
          // }

          {
            isfilter("gst_sales_5_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_5_taxable_amount
                  ? formatIndianNumber(item.gst_sales_5_taxable_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("cgst_2_5_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cgst_2_5_gst_amount
                  ? formatIndianNumber(item.cgst_2_5_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("sgst_2_5_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.sgst_2_5_gst_amount
                  ? formatIndianNumber(item.sgst_2_5_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("i_gst_sales_5_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_5_taxable_amount
                  ? formatIndianNumber(item.i_gst_sales_5_taxable_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("igst_5_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.igst_5_gst_amount
                  ? formatIndianNumber(item.igst_5_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("gst_sales_12_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_12_taxable_amount
                  ? formatIndianNumber(item.gst_sales_12_taxable_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("cgst_6_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cgst_6_gst_amount
                  ? formatIndianNumber(item.cgst_6_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("sgst_6_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.sgst_6_gst_amount
                  ? formatIndianNumber(item.sgst_6_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("i_gst_sales_12_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_12_taxable_amount
                  ? formatIndianNumber(item.i_gst_sales_12_taxable_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("igst_12_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.igst_12_gst_amount
                  ? formatIndianNumber(item.igst_12_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("gst_sales_18_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_18_taxable_amount
                  ? formatIndianNumber(item.gst_sales_18_taxable_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("cgst_9_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cgst_9_gst_amount
                  ? formatIndianNumber(item.cgst_9_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("sgst_9_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.sgst_9_gst_amount
                  ? formatIndianNumber(item.sgst_9_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("i_gst_sales_18_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_18_taxable_amount
                  ? formatIndianNumber(item.i_gst_sales_18_taxable_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("igst_18_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.igst_18_gst_amount
                  ? formatIndianNumber(item.igst_18_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("gst_sales_28_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_28_taxable_amount
                  ? formatIndianNumber(item.gst_sales_28_taxable_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("sgst_14_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.sgst_14_gst_amount
                  ? formatIndianNumber(item.sgst_14_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("cgst_14_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cgst_14_gst_amount
                  ? formatIndianNumber(item.cgst_14_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("i_gst_sales_28_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_28_taxable_amount
                  ? formatIndianNumber(item.i_gst_sales_28_taxable_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("igst_28_gst_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.igst_28_gst_amount
                  ? formatIndianNumber(item.igst_28_gst_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("cess_12_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cess_12_taxable_amount
                  ? formatIndianNumber(item.cess_12_taxable_amount)
                  : ""
              }</td>`);
          }
          // {
          //   isfilter("gst_sales_nill_rate_ledger_name") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${group.length}" style="text-align:end;">${item.gst_sales_nill_rate_ledger_name}</td>`);
          // }
          {
            isfilter("gst_sales_nill_rate_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_nill_rate_taxable_amount
                  ? formatIndianNumber(item.gst_sales_nill_rate_taxable_amount)
                  : ""
              }</td>`);
          }
          {
            isfilter("i_gst_sales_nill_rate_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_nill_rate_taxable_amount
                  ? formatIndianNumber(
                      item.i_gst_sales_nill_rate_taxable_amount
                    )
                  : ""
              }</td>`);
          }
          {
            isfilter("frieght") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.frieght ? formatIndianNumber(item.frieght) : ""
              }</td>`);
          }
          {
            isfilter("gross_total") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gross_total ? formatIndianNumber(item.gross_total) : ""
              }</td>`);
          }
          {
            isfilter("terms_day") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:center;">${
                item.terms_day ? item.terms_day : ""
              }</td>`);
          }
          {
            isfilter("due_date") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:center;">${
                item?.due_date
                  ? moment(item?.due_date, "DD/MM/YYYY").format("DD MMM YYYY")
                  : ""
              }</td>`);
          }
          {
            isfilter("vehicle_no") &&
              index === 0 &&
              (content += `<td rowspan="${group.length}" >${item.vehicle_no}</td>`);
          }
          {
            isfilter("cartoon") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:center;">${
                item.cartoon ? item.cartoon : ""
              }</td>`);
          }
          {
            isfilter("bag") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:center;">${item.bag ? item.bag : ""}</td>`);
          }
          content += "</tr>";
        })
      );
      if (data && data?.length > 0) {
        content += '<tr style="background:whitesmoke; font-weight:600;">';
        content += `<td>Total</td>`;

        {
          isfilter("voucher_type_name") && (content += `<td></td>`);
        }
        {
          isfilter("invoice_date") && (content += `<td></td>`);
        }
        {
          isfilter("account_name") && (content += `<td ></td>`);
        }
        {
          isfilter("product_name") && (content += `<td></td>`);
        }
        {
          isfilter("lot_no") && (content += `<td></td>`);
        }
        {
          isfilter("quantity") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalQty
            )}</td>`);
        }
        {
          isfilter("free_quantity") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalFreeQty
            )}</td>`);
        }
        {
          isfilter("unit_name") && (content += `<td></td>`);
        }
        {
          isfilter("mrp") && (content += `<td></td>`);
        }
        {
          isfilter("rate") && (content += `<td style="text-align:end;"></td>`);
        }
        {
          isfilter("vatav_per") &&
            (content += `<td style="text-align:end;"></td>`);
        }
        {
          isfilter("vatav") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalVatav
            )}</td>`);
        }
        {
          isfilter("taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalTaxableAmount
            )}</td>`);
        }
        {
          isfilter("cgst") && (content += `<td style="text-align:end;"></td>`);
        }
        {
          isfilter("cgst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalCGSTAmount
            )}</td>`);
        }
        {
          isfilter("sgst") && (content += `<td style="text-align:end;"></td>`);
        }
        {
          isfilter("sgst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalSGSTAmount
            )}</td>`);
        }
        {
          isfilter("igst") && (content += `<td style="text-align:end;"></td>`);
        }
        {
          isfilter("igst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalIGSTAmount
            )}</td>`);
        }
        {
          isfilter("total_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGSTWithAmount
            )}</td>`);
        }
        {
          isfilter("total_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandTaxableAmount
            )}</td>`);
        }
        // {
        //   isfilter("total_cgst") &&
        //     (content += `<td  style="text-align:end;">${formatIndianNumber(
        //       GrandtotalCGSTAmount
        //     )}</td>`);
        // }
        // {
        //   isfilter("total_sgst") &&
        //     (content += `<td  style="text-align:end;">${formatIndianNumber(
        //       GrandtotalSGSTAmount
        //     )}</td>`);
        // }
        // {
        //   isfilter("total_igst") &&
        //     (content += `<td style="text-align:end;">${formatIndianNumber(
        //       GrandtotalIGSTAmount
        //     )}</td>`);
        // }
        {
          isfilter("gst_sales_5_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesGST5Amount
            )}</td>`);
        }
        {
          isfilter("cgst_2_5_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCGST2_5Amount
            )}</td>`);
        }
        {
          isfilter("sgst_2_5_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSGST2_5Amount
            )}</td>`);
        }
        {
          isfilter("i_gst_sales_5_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesIGST5Amount
            )}</td>`);
        }
        {
          isfilter("igst_5_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGST5Amount
            )}</td>`);
        }
        {
          isfilter("gst_sales_12_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesGST12Amount
            )}</td>`);
        }
        {
          isfilter("cgst_6_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCGST6Amount
            )}</td>`);
        }
        {
          isfilter("sgst_6_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSGST6Amount
            )}</td>`);
        }
        {
          isfilter("i_gst_sales_12_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesIGST12Amount
            )}</td>`);
        }
        {
          isfilter("igst_12_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGST12Amount
            )}</td>`);
        }
        {
          isfilter("gst_sales_18_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesGST18Amount
            )}</td>`);
        }
        {
          isfilter("cgst_9_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCGST9Amount
            )}</td>`);
        }
        {
          isfilter("sgst_9_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSGST9Amount
            )}</td>`);
        }
        {
          isfilter("i_gst_sales_18_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesIGST18Amount
            )}</td>`);
        }
        {
          isfilter("igst_18_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGST18Amount
            )}</td>`);
        }
        {
          isfilter("gst_sales_28_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesGST28Amount
            )}</td>`);
        }
        {
          isfilter("sgst_14_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCGST14Amount
            )}</td>`);
        }
        {
          isfilter("cgst_14_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSGST14Amount
            )}</td>`);
        }
        {
          isfilter("i_gst_sales_28_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesIGST28Amount
            )}</td>`);
        }
        {
          isfilter("igst_28_gst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGST28Amount
            )}</td>`);
        }
        {
          isfilter("cess_12_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCESS12Amount
            )}</td>`);
        }

        // {
        //   isfilter("gst_sales_nill_rate_ledger_name") &&
        //     (content += `<td style="text-align:end;"></td>`);
        // }
        {
          isfilter("gst_sales_nill_rate_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandGSTSalesTaxableAmount
            )}</td>`);
        }
        {
          isfilter("i_gst_sales_nill_rate_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGSTSalesTaxableAmount
            )}</td>`);
        }

        {
          isfilter("frieght") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalFreightAmount
            )}</td>`);
        }
        {
          isfilter("gross_total") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              GrandTotalAmount
            )}</td>`);
        }
        {
          isfilter("terms_day") &&
            (content += `<td style="text-align:center;"></td>`);
        }
        {
          isfilter("due_date") &&
            (content += `<td  style="text-align:center;"></td>`);
        }
        {
          isfilter("vehicle_no") && (content += `<td  ></td>`);
        }
        {
          isfilter("cartoon") &&
            (content += `<td style="text-align:center;"></td>`);
        }
        {
          isfilter("bag") &&
            (content += `<td style="text-align:center;"></td>`);
        }
        content += "</tr>";
      }

      content += "</tbody>";
      content += "</table>";

      content += "</div>";
    }

    let printWindow = window.open("", "_blank");
    if (!printWindow) {
      console.error("Failed to open print preview window.");
      return;
    }
    printWindow.document.write(`
        <html>
        <head>
          <title>Print Preview</title>
          <style>
            @page { margin: 1cm; }
            .print-page { page-break-after: always; }
            .table-bordered { width: 100%; border-collapse: collapse; }
            .table-bordered th, .table-bordered td { border: 1px solid black; padding: 8px; }
            body { font-family: Arial, sans-serif; }
          </style>
        </head>
        <body>
          ${content}
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
        </html>
      `);
    printWindow.document.close();

    if (printbuttons) printbuttons.style.display = "block";
    if (report_container) report_container.style.padding = "20px 10px";
  };

  // const calculateRowSpans = (data: any[]) => {
  //   const rowSpans: any = {};

  //   data.forEach((item: any, index: number) => {
  //     const { invoice_no, vendor_id } = item;
  //     if (!rowSpans[invoice_no]) {
  //       rowSpans[invoice_no] = {};
  //     }

  //     if (!rowSpans[invoice_no][vendor_id]) {
  //       rowSpans[invoice_no][vendor_id] = { count: 1, index };
  //     } else {
  //       rowSpans[invoice_no][vendor_id].count++;
  //     }
  //   });

  //   return rowSpans;
  // };

  // const rowSpans = calculateRowSpans(SalesRegisterList);

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {SalesRegisterList && SalesRegisterList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            const isMatchFound = GrandTotalArray?.some((subItem: any) =>
              formRenderProps.valueGetter("filter_columns")?.includes(subItem)
            );
            const isfilter = (key: string) =>
              formRenderProps.valueGetter("filter_columns")?.includes(key);
            return (
              <FormElement
                style={{ width: "100%", minHeight: "calc(100vh - 318px)" }}
              >
                <GridLayout
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h4 className="m-0">
                      Sales Register List{" "}
                      {(SalesRegisterDetails?.from_date ||
                        SalesRegisterDetails?.to_date) && (
                        <span style={{ fontSize: 13 }}>
                          {"("}
                          {SalesRegisterDetails?.from_date
                            ? moment(
                                SalesRegisterDetails?.from_date,
                                "YYYY-MM-DD"
                              ).format("DD/MM/YYYY")
                            : ""}
                          {SalesRegisterDetails?.from_date &&
                            SalesRegisterDetails?.to_date &&
                            " - "}
                          {SalesRegisterDetails?.to_date
                            ? moment(
                                SalesRegisterDetails?.to_date,
                                "YYYY-MM-DD"
                              ).format("DD/MM/YYYY")
                            : ""}
                          {")"}
                        </span>
                      )}
                    </Typography.h4>
                    <div className="position-relative d-flex">
                      {isPrintAccess && (
                        <Button
                          style={{ marginRight: 5 }}
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={() =>
                            printTable(groupedArray, formRenderProps)
                          }
                        >
                          Print
                        </Button>
                      )}
                      {isExcelAccess && (
                        <Button
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={handleExportExcel}
                          style={{ marginRight: 5 }}
                        >
                          Excel Export
                        </Button>
                      )}
                      <Tooltip
                        anchorElement="target"
                        position="left"
                        parentTitle={true}
                      >
                        <Button
                          title="Filter Columns"
                          type="button"
                          themeColor={"primary"}
                          fillMode={"solid"}
                          onClick={() => setShowFilterColumns(true)}
                        >
                          Filter
                          <BsThreeDotsVertical />
                        </Button>
                      </Tooltip>
                      {showfilterColumns && (
                        <div
                          style={{
                            position: "absolute",
                            top: "32px",
                            right: "0",
                            background: "white",
                            padding: "12px",
                            border: "1px solid whitesmoke",
                            width: "250px",
                            zIndex: 2,
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-baseline">
                            <p className="m-0 fw-600">Filter</p>
                            <Button
                              themeColor={"primary"}
                              fillMode={"flat"}
                              onClick={() => setShowFilterColumns(false)}
                            >
                              <RxCross2 />
                            </Button>
                          </div>
                          <hr className="m-1" style={{ color: "lightgray" }} />
                          <Field
                            wrapperClassName="d-flex flex-column checkBoxGroup-vertical"
                            inputClassName="checkBoxGroup-vertical-input"
                            id={"filter_columns"}
                            name={"filter_columns"}
                            marginRight={0}
                            marginBeetween={8}
                            component={FormCheckboxGroup}
                            options={columns}
                          />
                        </div>
                      )}
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      maxHeight: "calc(100vh - 362px)",
                      overflow: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className="table table-bordered w-100  currentstock-print-table"
                      style={{
                        marginTop: 1,
                      }}
                    >
                      <tr
                        className="text-center fw-600"
                        style={{
                          fontSize: 12,
                          position: "sticky",
                          top: 0,
                          outline: "1px solid #3b3b3b",
                          zIndex: 1,
                        }}
                      >
                        {/* {isfilter("invoice_no") && ( */}
                        <th style={{ minWidth: 200 }}>Invoice No.</th>
                        {/* )} */}
                        {isfilter("voucher_type_name") && (
                          <th style={{ minWidth: 120 }}>Voucher Type</th>
                        )}
                        {isfilter("invoice_date") && (
                          <th style={{ minWidth: 120 }}>Invoice Date</th>
                        )}
                        {isfilter("account_name") && (
                          <th style={{ minWidth: 250 }}>Customer Name</th>
                        )}
                        {isfilter("product_name") && (
                          <th style={{ minWidth: 250 }}>Item Name</th>
                        )}
                        {isfilter("lot_no") && (
                          <th style={{ minWidth: 100 }}>Lot No</th>
                        )}
                        {isfilter("quantity") && (
                          <th style={{ minWidth: 150 }}>Qty</th>
                        )}
                        {isfilter("free_quantity") && (
                          <th style={{ minWidth: 150 }}>Free Qty</th>
                        )}
                        {isfilter("unit_name") && (
                          <th style={{ minWidth: 100 }}>Unit</th>
                        )}
                        {isfilter("mrp") && (
                          <th style={{ minWidth: 120 }}>MRP</th>
                        )}
                        {isfilter("rate") && (
                          <th style={{ minWidth: 120 }}>Rate</th>
                        )}
                        {isfilter("vatav_per") && (
                          <th style={{ minWidth: 80 }}>Vatav(%)</th>
                        )}
                        {isfilter("vatav") && (
                          <th style={{ minWidth: 120 }}>Vatav</th>
                        )}
                        {isfilter("taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Taxable Amount</th>
                        )}
                        {isfilter("cgst") && (
                          <th style={{ minWidth: 100 }}>CGST(%)</th>
                        )}
                        {isfilter("cgst_amount") && (
                          <th style={{ minWidth: 150 }}>CGST Amount</th>
                        )}
                        {isfilter("sgst") && (
                          <th style={{ minWidth: 100 }}>SGST(%)</th>
                        )}
                        {isfilter("sgst_amount") && (
                          <th style={{ minWidth: 150 }}>SGST Amount</th>
                        )}
                        {isfilter("igst") && (
                          <th style={{ minWidth: 100 }}>IGST(%)</th>
                        )}
                        {isfilter("igst_amount") && (
                          <th style={{ minWidth: 150 }}>IGST Amount</th>
                        )}
                        {isfilter("total_amount") && (
                          <th style={{ minWidth: 150 }}>Total Amount</th>
                        )}
                        {isfilter("total_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>
                            Total Taxable Amount
                          </th>
                        )}
                        {/* {isfilter("total_cgst") && (
                          <th style={{ minWidth: 150 }}>Total CGST Amount</th>
                        )}
                        {isfilter("total_sgst") && (
                          <th style={{ minWidth: 150 }}>Total SGST Amount</th>
                        )}
                        {isfilter("total_igst") && (
                          <th style={{ minWidth: 150 }}>Total IGST Amount</th>
                        )} */}

                        {isfilter("gst_sales_5_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales GST 5%</th>
                        )}
                        {isfilter("cgst_2_5_gst_amount") && (
                          <th style={{ minWidth: 150 }}>CGST 2.5%</th>
                        )}
                        {isfilter("sgst_2_5_gst_amount") && (
                          <th style={{ minWidth: 150 }}>SGST 2.5%</th>
                        )}
                        {isfilter("i_gst_sales_5_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales IGST 5%</th>
                        )}
                        {isfilter("igst_5_gst_amount") && (
                          <th style={{ minWidth: 150 }}>IGST 5%</th>
                        )}

                        {isfilter("gst_sales_12_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales GST 12%</th>
                        )}
                        {isfilter("cgst_6_gst_amount") && (
                          <th style={{ minWidth: 150 }}>CGST 6%</th>
                        )}
                        {isfilter("sgst_6_gst_amount") && (
                          <th style={{ minWidth: 150 }}>SGST 6%</th>
                        )}
                        {isfilter("i_gst_sales_12_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales IGST 12%</th>
                        )}
                        {isfilter("igst_12_gst_amount") && (
                          <th style={{ minWidth: 150 }}>IGST 12%</th>
                        )}

                        {isfilter("gst_sales_18_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales GST 18%</th>
                        )}
                        {isfilter("cgst_9_gst_amount") && (
                          <th style={{ minWidth: 150 }}>CGST 9%</th>
                        )}
                        {isfilter("sgst_9_gst_amount") && (
                          <th style={{ minWidth: 150 }}>SGST 9%</th>
                        )}
                        {isfilter("i_gst_sales_18_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales IGST 18%</th>
                        )}
                        {isfilter("igst_18_gst_amount") && (
                          <th style={{ minWidth: 150 }}>IGST 18%</th>
                        )}

                        {isfilter("gst_sales_28_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales GST 28%</th>
                        )}
                        {isfilter("cgst_14_gst_amount") && (
                          <th style={{ minWidth: 150 }}>CGST 14%</th>
                        )}
                        {isfilter("sgst_14_gst_amount") && (
                          <th style={{ minWidth: 150 }}>SGST 14%</th>
                        )}
                        {isfilter("i_gst_sales_28_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales IGST 28%</th>
                        )}
                        {isfilter("igst_28_gst_amount") && (
                          <th style={{ minWidth: 150 }}>IGST 28%</th>
                        )}
                        {isfilter("cess_12_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>CESS 12%</th>
                        )}
                        {/* {isfilter("gst_sales_nill_rate_ledger_name") && (
                          <th style={{ minWidth: 300 }}>
                            GST Sales Nill Rate Ledger Name
                          </th>
                        )} */}
                        {isfilter("gst_sales_nill_rate_taxable_amount") && (
                          <th style={{ minWidth: 300 }}>
                            GST Sales Nill Rate Amount
                          </th>
                        )}
                        {isfilter("i_gst_sales_nill_rate_taxable_amount") && (
                          <th style={{ minWidth: 300 }}>
                            IGST Sales Nill Rate Amount
                          </th>
                        )}

                        {/* {isfilter("packing") && (
                          <th style={{ minWidth: 150 }}>Packing</th>
                        )}
                        {isfilter("dalali") && (
                          <th style={{ minWidth: 150 }}>Dalali</th>
                        )}
                        {isfilter("labour") && (
                          <th style={{ minWidth: 150 }}>Labour</th>
                        )} */}

                        {isfilter("frieght") && (
                          <th style={{ minWidth: 100 }}>Freight</th>
                        )}
                        {isfilter("gross_total") && (
                          <th style={{ minWidth: 150 }}>Grand Total Amount</th>
                        )}
                        {isfilter("terms_day") && (
                          <th style={{ minWidth: 80 }}>Terms Day</th>
                        )}
                        {isfilter("due_date") && (
                          <th style={{ minWidth: 120 }}>Due Date</th>
                        )}
                        {isfilter("vehicle_no") && (
                          <th style={{ minWidth: 120 }}>Vehicle No.</th>
                        )}
                        {isfilter("cartoon") && (
                          <th style={{ minWidth: 100 }}>Cartoon</th>
                        )}
                        {isfilter("bag") && (
                          <th style={{ minWidth: 100 }}>Bag</th>
                        )}
                      </tr>
                      {groupedArray &&
                        groupedArray?.length > 0 &&
                        groupedArray?.map((group: any) =>
                          group.map((item: any, index: number) => {
                            const groupKey = `${item?.sale_guid}`;
                            const isSelected = selectedGroup === groupKey;

                            return (
                              <tr
                                className={`text-center`}
                                style={{
                                  background: isSelected
                                    ? "rgb(255 198 198 / 53%)"
                                    : "transparent",
                                }}
                                onClick={() => handleRowClick(item.sale_guid)}
                              >
                                {index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-start register-edit-column"
                                  >
                                    {item.invoice_no_string}
                                    {isEditAccess && (
                                      <IconButton
                                        type="button"
                                        fillMode="flat"
                                        themeColor={"primary"}
                                        ref={isEditBtnRef}
                                        size="small"
                                        style={{
                                          padding: "15px",
                                          marginLeft: "5px",
                                        }}
                                        onClick={() => {
                                          isEditBtnRef.current = true;
                                          navigate("/sales/edit", {
                                            state: {
                                              sale_guid: item?.sale_guid,
                                            },
                                          });
                                        }}
                                      >
                                        <FiEdit
                                          className="absolute-position"
                                          style={{
                                            fontSize: "20px",
                                            zIndex: 0,
                                            color: "red",
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </td>
                                )}
                                {isfilter("voucher_type_name") &&
                                  index === 0 && (
                                    <td rowSpan={group.length}>
                                      {item.voucher_type_name}
                                    </td>
                                  )}
                                {isfilter("invoice_date") && index === 0 && (
                                  <td rowSpan={group.length}>
                                    {item.invoice_date
                                      ? moment(
                                          item.invoice_date,
                                          "DD/MM/YYYY"
                                        )?.format("DD MMM YYYY")
                                      : ""}
                                  </td>
                                )}
                                {isfilter("account_name") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-start"
                                  >
                                    {item?.account_name}
                                  </td>
                                )}
                                {isfilter("product_name") && (
                                  <td className="text-start">
                                    {item?.product_name}
                                  </td>
                                )}
                                {isfilter("lot_no") && <td>{item?.lot_no}</td>}
                                {isfilter("quantity") && (
                                  <td className="text-end">
                                    {formatIndianNumberForQty(item?.quantity) ||
                                      0}
                                  </td>
                                )}
                                {isfilter("free_quantity") && (
                                  <td className="text-end">
                                    {formatIndianNumberForQty(
                                      item?.free_quantity
                                    ) || 0}
                                  </td>
                                )}
                                {isfilter("unit_name") && (
                                  <td>{item?.unit_code}</td>
                                )}
                                {isfilter("mrp") && (
                                  <td className="text-end">{item?.mrp}</td>
                                )}
                                {isfilter("rate") && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.rate || 0)}
                                  </td>
                                )}
                                {isfilter("vatav_per") && (
                                  <td className="text-end">
                                    {item?.vatav_per
                                      ? `${item?.vatav_per} %`
                                      : ""}
                                  </td>
                                )}
                                {isfilter("vatav") && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.vatav)}
                                  </td>
                                )}
                                {isfilter("taxable_amount") && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.taxable_amount || 0
                                    )}
                                  </td>
                                )}
                                {isfilter("cgst") && (
                                  <td className="text-end">
                                    {item?.cgst ? `${item?.cgst} %` : ""}
                                  </td>
                                )}
                                {isfilter("cgst_amount") && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.cgst_amount)}
                                  </td>
                                )}
                                {isfilter("sgst") && (
                                  <td className="text-end">
                                    {item?.sgst ? `${item?.sgst} %` : ""}
                                  </td>
                                )}
                                {isfilter("sgst_amount") && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.sgst_amount)}
                                  </td>
                                )}
                                {isfilter("igst") && (
                                  <td className="text-end">
                                    {item?.igst ? `${item?.igst} %` : ""}
                                  </td>
                                )}
                                {isfilter("igst_amount") && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.igst_amount)}
                                  </td>
                                )}
                                {isfilter("total_amount") && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.total_amount || 0
                                    )}
                                  </td>
                                )}
                                {isfilter("total_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.total_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {/* {isfilter("total_cgst") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-end"
                                  >
                                    {formatIndianNumber(item?.total_cgst)}
                                  </td>
                                )}
                                {isfilter("total_sgst") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-end"
                                  >
                                    {formatIndianNumber(item?.total_sgst)}
                                  </td>
                                )}
                                {isfilter("total_igst") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-end"
                                  >
                                    {formatIndianNumber(item?.total_igst)}
                                  </td>
                                )} */}

                                {isfilter("gst_sales_5_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_5_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("cgst_2_5_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cgst_2_5_gst_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("sgst_2_5_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.sgst_2_5_gst_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("i_gst_sales_5_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_5_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("igst_5_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.igst_5_gst_amount
                                      )}
                                    </td>
                                  )}

                                {isfilter("gst_sales_12_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_12_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("cgst_6_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cgst_6_gst_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("sgst_6_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.sgst_6_gst_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("i_gst_sales_12_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_12_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("igst_12_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.igst_12_gst_amount
                                      )}
                                    </td>
                                  )}

                                {isfilter("gst_sales_18_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_18_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("cgst_9_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cgst_9_gst_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("sgst_9_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.sgst_9_gst_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("i_gst_sales_18_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_18_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("igst_18_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.igst_18_gst_amount
                                      )}
                                    </td>
                                  )}

                                {isfilter("gst_sales_28_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_28_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("cgst_14_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cgst_14_gst_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("sgst_14_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.sgst_14_gst_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("i_gst_sales_28_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_28_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("igst_28_gst_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.igst_28_gst_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter("cess_12_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cess_12_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {/* {isfilter("gst_sales_nill_rate_ledger_name") &&
                                  index === 0 && (
                                    <td rowSpan={group.length}>
                                      {item?.gst_sales_nill_rate_ledger_name}
                                    </td>
                                  )} */}
                                {isfilter(
                                  "gst_sales_nill_rate_taxable_amount"
                                ) &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_nill_rate_taxable_amount
                                      )}
                                    </td>
                                  )}
                                {isfilter(
                                  "i_gst_sales_nill_rate_taxable_amount"
                                ) &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_nill_rate_taxable_amount
                                      )}
                                    </td>
                                  )}

                                {/* {isfilter("packing") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-end"
                                  >
                                    {formatIndianNumber(item?.packing)}
                                  </td>
                                )}
                                {isfilter("dalali") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-end"
                                  >
                                    {formatIndianNumber(item?.dalali)}
                                  </td>
                                )}
                                {isfilter("labour") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-end"
                                  >
                                    {formatIndianNumber(item?.labour)}
                                  </td>
                                )} */}
                                {isfilter("frieght") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-end"
                                  >
                                    {formatIndianNumber(item?.frieght || 0)}
                                  </td>
                                )}
                                {isfilter("gross_total") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-end"
                                  >
                                    {formatIndianNumber(item?.gross_total || 0)}
                                  </td>
                                )}
                                {isfilter("terms_day") && index === 0 && (
                                  <td rowSpan={group.length}>
                                    {item?.terms_day}
                                  </td>
                                )}
                                {isfilter("due_date") && index === 0 && (
                                  <td rowSpan={group.length}>
                                    {item?.due_date}
                                  </td>
                                )}
                                {isfilter("vehicle_no") && index === 0 && (
                                  <td rowSpan={group.length}>
                                    {item?.vehicle_no}
                                  </td>
                                )}
                                {isfilter("cartoon") && index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-start"
                                  >
                                    {item?.cartoon}
                                  </td>
                                )}
                                {isfilter("bag") && index === 0 && (
                                  <td rowSpan={group.length}>{item?.bag}</td>
                                )}
                              </tr>
                            );
                          })
                        )}
                      {groupedArray &&
                        groupedArray?.length > 0 &&
                        isMatchFound && (
                          <tr
                            className="text-center"
                            style={{
                              background: "whitesmoke",
                              fontWeight: 600,
                            }}
                          >
                            <td className="text-start">Total</td>
                            {isfilter("voucher_type_name") && <td></td>}
                            {isfilter("invoice_date") && <td></td>}
                            {isfilter("account_name") && (
                              <td className="text-start"></td>
                            )}
                            {isfilter("product_name") && (
                              <td className="text-start"></td>
                            )}
                            {isfilter("lot_no") && <td></td>}
                            {isfilter("quantity") && (
                              <td className="text-end">
                                {formatIndianNumberForQty(totalQty)}
                              </td>
                            )}
                            {isfilter("free_quantity") && (
                              <td className="text-end">
                                {formatIndianNumberForQty(totalFreeQty)}
                              </td>
                            )}
                            {isfilter("unit_name") && <td></td>}
                            {isfilter("mrp") && <td className="text-end"></td>}
                            {isfilter("rate") && <td className="text-end"></td>}
                            {isfilter("vatav_per") && (
                              <td className="text-end"></td>
                            )}
                            {isfilter("vatav") && (
                              <td className="text-end">
                                {formatIndianNumber(totalVatav)}
                              </td>
                            )}
                            {isfilter("taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalTaxableAmount)}
                              </td>
                            )}
                            {isfilter("cgst") && <td className="text-end"></td>}
                            {isfilter("cgst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalCGSTAmount)}
                              </td>
                            )}
                            {isfilter("sgst") && <td className="text-end"></td>}
                            {isfilter("sgst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalSGSTAmount)}
                              </td>
                            )}
                            {isfilter("igst") && <td className="text-end"></td>}
                            {isfilter("igst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalIGSTAmount)}
                              </td>
                            )}
                            {isfilter("total_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGSTWithAmount)}
                              </td>
                            )}
                            {isfilter("total_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandTaxableAmount)}
                              </td>
                            )}
                            {/* {isfilter("total_cgst") && (
                              <td className="text-end">
                                {formatIndianNumber(GrandtotalCGSTAmount)}
                              </td>
                            )}
                            {isfilter("total_sgst") && (
                              <td className="text-end">
                                {formatIndianNumber(GrandtotalSGSTAmount)}
                              </td>
                            )}
                            {isfilter("total_igst") && (
                              <td className="text-end">
                                {formatIndianNumber(GrandtotalIGSTAmount)}
                              </td>
                            )} */}

                            {isfilter("gst_sales_5_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesGST5Amount)}
                              </td>
                            )}
                            {isfilter("cgst_2_5_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCGST2_5Amount)}
                              </td>
                            )}
                            {isfilter("sgst_2_5_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSGST2_5Amount)}
                              </td>
                            )}
                            {isfilter("i_gst_sales_5_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesIGST5Amount)}
                              </td>
                            )}
                            {isfilter("igst_5_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandIGST5Amount)}
                              </td>
                            )}
                            {isfilter("gst_sales_12_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesGST12Amount)}
                              </td>
                            )}
                            {isfilter("cgst_6_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCGST6Amount)}
                              </td>
                            )}
                            {isfilter("sgst_6_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSGST6Amount)}
                              </td>
                            )}
                            {isfilter("i_gst_sales_12_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandSalesIGST12Amount
                                )}
                              </td>
                            )}
                            {isfilter("igst_12_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandIGST12Amount)}
                              </td>
                            )}
                            {isfilter("gst_sales_18_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesGST18Amount)}
                              </td>
                            )}
                            {isfilter("cgst_9_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCGST9Amount)}
                              </td>
                            )}
                            {isfilter("sgst_9_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSGST9Amount)}
                              </td>
                            )}
                            {isfilter("i_gst_sales_18_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandSalesIGST18Amount
                                )}
                              </td>
                            )}
                            {isfilter("igst_18_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandIGST18Amount)}
                              </td>
                            )}
                            {isfilter("gst_sales_28_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesGST28Amount)}
                              </td>
                            )}
                            {isfilter("cgst_14_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCGST14Amount)}
                              </td>
                            )}
                            {isfilter("sgst_14_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSGST14Amount)}
                              </td>
                            )}
                            {isfilter("i_gst_sales_28_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandSalesIGST28Amount
                                )}
                              </td>
                            )}
                            {isfilter("igst_28_gst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandIGST28Amount)}
                              </td>
                            )}
                            {isfilter("cess_12_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCESS12Amount)}
                              </td>
                            )}
                            {/* {isfilter("gst_sales_nill_rate_ledger_name") && (
                              <td className="text-end"></td>
                            )} */}
                            {isfilter("gst_sales_nill_rate_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandGSTSalesTaxableAmount
                                )}
                              </td>
                            )}
                            {isfilter(
                              "i_gst_sales_nill_rate_taxable_amount"
                            ) && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandIGSTSalesTaxableAmount
                                )}
                              </td>
                            )}

                            {/* {isfilter("packing") && (
                              <td className="text-end">
                                {formatIndianNumber(totalPackingAmount)}
                              </td>
                            )}
                            {isfilter("dalali") && (
                              <td className="text-end">
                                {formatIndianNumber(totalDalaliAmount)}
                              </td>
                            )}
                            {isfilter("labour") && (
                              <td className="text-end">
                                {formatIndianNumber(totalLabourAmount)}
                              </td>
                            )} */}
                            {isfilter("frieght") && (
                              <td className="text-end">
                                {formatIndianNumber(totalFreightAmount)}
                              </td>
                            )}
                            {isfilter("gross_total") && (
                              <td className="text-end">
                                {formatIndianNumber(GrandTotalAmount)}
                              </td>
                            )}
                            {isfilter("terms_day") && <td></td>}
                            {isfilter("due_date") && <td></td>}
                            {isfilter("vehicle_no") && <td></td>}
                            {isfilter("cartoon") && (
                              <td className="text-start"></td>
                            )}
                            {isfilter("bag") && <td></td>}
                          </tr>
                        )}
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};
export default SalesRegisterReportForm;
